import {
	TRIGGER_TYPES,
	TRIGGER_OPERATOR_CODES,
	VALIDATION_OPERATORS
} from "screens/rule-provider/constants.js";
import {
	filter,
	find,
	some,
	uniqWith,
	remove,
	forEach,
	uniq
} from "lodash";
import { REPORT_SCOPES } from "constants.js";

class validationService {
	constructor($logger) {
		this.hasPendingValidations = false;
		this.$logger = $logger;
	}

	init(formRules = [], formFields) {
		this.formRules = formRules;
		this.formFields = formFields;
		this.ruleValidations = [];

		formRules.map((rule) => this.getRuleFields(rule));
	}

	updateApiValidations(validations = []) {
		this.findTriggeredRules(validations);
		this.updateRuleValidations();
	}

	getRuleById(id) {
		const thisRule = find(this.formRules, r => r.Id === id);

		return { ...thisRule };
	}

	updateTriggeredRules(rules = [], scopes, detailId) {
		forEach(scopes, (scope) => {
			if(scope === REPORT_SCOPES.details || scope === REPORT_SCOPES.report || scope === REPORT_SCOPES.reportAndDetails) {
				remove(this.triggeredRules, (rule) => {
					return rule.DetailId === undefined && rule.validationScope.Code === scope;
				});
			}
			else {
				remove(this.triggeredRules, (rule) => {
					return rule.DetailId === detailId && rule.validationScope.Code === scope;
				});
			}
		});

		this.triggeredRules = this.triggeredRules || [];

		this.triggeredRules = this.triggeredRules.concat(rules);
		this.triggeredRules = uniqWith(this.triggeredRules, (currRule, lastRule) => {
			let isSameDetail = currRule.Id === lastRule.Id
				&& (
					// it's run over the same detailId OR one of the details was actually the header, we treat it as the same detail
					// This can happen when the rule wis REPORTANDDETAILS scoped and a detail is being saved, 
					// it will be evaluated both from the perspective of the saving detail AND the perspective of the header, 
					// resulting in 2 evaluations, one with a DetailId and one without.
					currRule.DetailId === lastRule.DetailId || currRule.DetailId === undefined || lastRule.DetailId === undefined
				);

			if(currRule.DetailId === undefined && lastRule.DetailId === undefined
				&& currRule.DetailLinkKey !== undefined && lastRule.DetailLinkKey !== undefined) {
				isSameDetail = isSameDetail && (lastRule.DetailLinkKey === currRule.DetailLinkKey);
			}

			return isSameDetail;
		});

		this.triggeredRules.map((rule) => this.getRuleFields(rule));
		this.updateRuleValidations();
	}

	getRuleValidationsOfType(validationOperator, detailId) {
		const type = {
			...find(this.ruleValidations,
				(v) => v.code === validationOperator
			)
		};

		const pendingType = {
			...find(this.pendingValidations,
				(v) => v.code === validationOperator
			)
		};

		if(pendingType && pendingType.rules && pendingType.rules.length > 0) {
			const combinedRules = (type?.rules || []).concat(pendingType.rules);
			type.rules = uniqWith(combinedRules, (next, curr) => next.Id === curr.Id && next.DetailId === curr.DetailId && next.repeatId === curr.repeatId);

			if(detailId) {
				type.rules = type.rules.filter(rule => rule.DetailId === detailId);
			}
		}

		return type;
	}

	getPendingValidationsOfType(validationOperator, detailId) {
		const type = {
			...find(this.pendingValidations,
				(v) => v.code === validationOperator
			)
		};

		if(type && type.rules && type.rules.length > 0) {
			type.rules = uniqWith(type.Rules, (next, curr) => next.Id === curr.Id && next.DetailId === curr.DetailId);

			if(detailId) {
				type.rules = type.rules.filter(rule => rule.DetailId === detailId);
			}
		}

		return type;
	}

	findTriggeredRules(validations = []) {
		const triggeredRules = validations.map((validation) => {
			const ruleId = validation.Rule.Id;

			const thisTriggeredRule = find(this.formRules, (formRule) => {
				return formRule.Id === ruleId;
			});

			if(thisTriggeredRule) {
				const newTriggeredRule = {
					...thisTriggeredRule,
					DetailId: validation.Detail && validation.Detail.Id,
					LinkKey: validation.Detail && validation.Detail.LinkKey
				};
				return newTriggeredRule;
			}
		});

		this.triggeredRules = triggeredRules.filter((rule) => !!rule); //filter out undefined rules, which are probably rules that fired then were removed from the config
	}

	updateRuleValidations() {
		this.formFields.map((field) => {
			field.hasValidationError = false;
			field.hasValidationWarning = false;
		});

		this.pendingValidations = VALIDATION_OPERATORS.map(o => {
			return {
				...o,
				rules: filter(this.triggeredRules, (r) => {
					return some(r.Triggers, (t) =>
						t.Operator.Code == o.code &&
						t.Type.Code === TRIGGER_TYPES.validation
					);
				})
			};
		});
		this.hasPendingValidations = true;

		this.updateFieldHighlights();
	}

	updateFieldHighlights(detailId) {
		const self = this;
		if(this.pendingValidations.length > 0) {
			this.pendingValidations.filter((scope) => scope.code === TRIGGER_OPERATOR_CODES.warning)[0].rules
				.map((rule) => {
					if(rule.Triggers && some(rule.Triggers, t => t.Operator.Code === TRIGGER_OPERATOR_CODES.highlight)) {
						const highlightTriggers = filter(rule.Triggers, t => t.Operator.Code === TRIGGER_OPERATOR_CODES.highlight);
						const conditionFields = findTriggerFields(rule, highlightTriggers);
						forEach(conditionFields, f => {
							applyWarningValidation(f, rule);
						});
					}

					else {
						rule.appliedFieldIds.map((fieldId) => {
							const conditionField = findConditionField(rule, fieldId);
							applyWarningValidation(conditionField, rule);
						});
					}
				});
			this.pendingValidations.filter((scope) => scope.code === TRIGGER_OPERATOR_CODES.blockSave)[0].rules
				.map((rule) => {
					if(rule.Triggers && some(rule.Triggers, t => t.Operator.Code === TRIGGER_OPERATOR_CODES.highlight)) {
						const highlightTriggers = filter(rule.Triggers, t => t.Operator.Code === TRIGGER_OPERATOR_CODES.highlight);
						const conditionFields = findTriggerFields(rule, highlightTriggers);
						forEach(conditionFields, f => {
							applyErrorValidation(f, rule);
						});
					}

					else {
						rule.appliedFieldIds.map((fieldId) => {
							const conditionField = findConditionField(rule, fieldId);
							applyErrorValidation(conditionField, rule);
						});
					}
				});
			this.pendingValidations.filter((scope) => scope.code === TRIGGER_OPERATOR_CODES.blockSubmit)[0].rules
				.map((rule) => {
					if(rule.Triggers && some(rule.Triggers, t => t.Operator.Code === TRIGGER_OPERATOR_CODES.highlight)) {
						const highlightTriggers = filter(rule.Triggers, t => t.Operator.Code === TRIGGER_OPERATOR_CODES.highlight);
						const conditionFields = findTriggerFields(rule, highlightTriggers);
						forEach(conditionFields, f => {
							applyErrorValidation(f, rule);
						});
					}

					else {
						rule.appliedFieldIds.map((fieldId) => {
							const conditionField = findConditionField(rule, fieldId);
							applyErrorValidation(conditionField, rule);
						});
					}
				});
		}

		function findConditionField(rule, fieldId) {
			const checkDetailId = !!rule.DetailId;
			const isRuleForDetail = (checkDetailId && rule.DetailId === detailId) || rule.Scope.Code === REPORT_SCOPES.reportAndDetails || rule.Scope.Code === REPORT_SCOPES.detail;
			const conditionField = find(self.formFields, (field) => {
				const isField = field.Id === fieldId;
				if(checkDetailId) {
					return isField && isRuleForDetail;
				}
				return isField;
			});

			return conditionField;
		}

		function findTriggerFields(rule, highlightTriggers) {
			const triggerFields = [];
			const checkDetailId = !!rule.DetailId;
			const isRuleForDetail = (checkDetailId && rule.DetailId === detailId) || rule.Scope.Code === REPORT_SCOPES.reportAndDetails;

			forEach(highlightTriggers, t => {
				if(isRuleForDetail || !checkDetailId) {
					const triggerField = find(self.formFields, (field) => {
						return field.Id === t.Field.Id;
					});
					triggerFields.push(triggerField);
				}
			});

			return triggerFields;
		}

		function applyErrorValidation(conditionField, rule) {
			conditionField && (conditionField.hasValidationError = true);
			if(conditionField && rule.repeatId) {
				conditionField.validationErrorRepeatIds = conditionField.validationErrorRepeatIds || [];
				conditionField.validationErrorRepeatIds.push(rule.repeatId);
			}
		}

		function applyWarningValidation(conditionField, rule) {
			conditionField && (conditionField.hasValidationWarning = true);
			if(conditionField && rule.repeatId) {
				conditionField.validationWarningRepeatIds = conditionField.validationWarningRepeatIds || [];
				conditionField.validationWarningRepeatIds.push(rule.repeatId);
			}
		}
	}

	commitValidations() {
		if(this.hasPendingValidations) {
			this.ruleValidations = this.pendingValidations;
		}
		else if(this.ruleValidations === undefined) {
			this.ruleValidations = [];
		}
		this.clearPendingValidations();
	}

	clearPendingValidations() {
		this.pendingValidations = [];
		this.hasPendingValidations = false;
	}

	getRuleFields(rule) {
		if(rule.Conditions) {
			rule.appliedFieldIds = uniq(rule.Conditions
				.map((cond) => cond.Field?.Id)
				.filter(id => id !== undefined));
			return;
		}

		rule.appliedFieldIds = uniq(rule.Children.map((child) => {
			this.getRuleFields(child);
			return child.appliedFieldIds;
		}).reduce((acc, curr) => acc.concat(curr)));
	}

	loadRulesForDetailModal(detailId) {
		this.pendingValidations = this.ruleValidations;
		this.hasPendingValidations = true;
		this.updateFieldHighlights(detailId);
	}
}

class validationServiceInstantiator {
	constructor($logger) {
		this.$logger = $logger;
	}

	getNewValidationService() {
		this.service = new validationService(this.$logger);
		return this.service;
	}

	getCurrentValidationService() {
		return this.service;
	}
}

export default angular
	.module("vesl.services.validation-service-factory", [])
	.service("validationServiceFactory", validationServiceInstantiator).name;
